const SUGGESTION_TYPES = {
  PRODUCT: 'product',
  SUB_MENU: 'subMenu',
  PRODUCT_TYPE: 'productType',
  SPECIFIC_PRODUCT: 'specificProduct',
};

class Suggestion {
  constructor(params) {
    this.type = params.type;
    this.text = params.text;
    this.id = params.id;
  }
}

export { Suggestion, SUGGESTION_TYPES };



// WEBPACK FOOTER //
// ./src/models/Suggestion.js